import * as React from "react";
import { forwardRef } from "react";
const SvgRightarrow = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 11, height: 10, viewBox: "0 0 11 10", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M5.59304 9.27697L4.69815 8.39202L7.8054 5.28478H0V3.99217H7.8054L4.69815 0.889893L5.59304 -2.26498e-05L10.2315 4.63847L5.59304 9.27697Z", fill: "#848B90" }));
const ForwardRef = forwardRef(SvgRightarrow);
export default ForwardRef;
